import styled from "@emotion/styled";
export const StyledDirectoryEmptyStateComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  text-align: center;
  margin-top: 32px;

  .empty-state-title {
    font-size: 1.75rem;
    font-weight: 400;

    margin-bottom: 8px;
  }

  .empty-state-subtitle {
    font-size: 0.875rem;
    line-height: 24px;

    width: 360px;
  }
`;
